'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Validator2 = require('./Validator');

var _Validator3 = _interopRequireDefault(_Validator2);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NumberValidator = function (_Validator) {
  _inherits(NumberValidator, _Validator);

  function NumberValidator() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        messageNotNumber = _ref.messageNotNumber,
        messageOnlyInteger = _ref.messageOnlyInteger,
        messageGreaterThan = _ref.messageGreaterThan,
        messageGreaterThanOrEqualTo = _ref.messageGreaterThanOrEqualTo,
        messageEqualTo = _ref.messageEqualTo,
        messageLessThan = _ref.messageLessThan,
        messageLessThanOrEqualTo = _ref.messageLessThanOrEqualTo,
        messageDivisibleBy = _ref.messageDivisibleBy,
        messageNotOdd = _ref.messageNotOdd,
        messageNotEven = _ref.messageNotEven,
        _ref$strict = _ref.strict,
        strict = _ref$strict === undefined ? false : _ref$strict,
        _ref$onlyInteger = _ref.onlyInteger,
        onlyInteger = _ref$onlyInteger === undefined ? false : _ref$onlyInteger,
        greaterThan = _ref.greaterThan,
        greaterThanOrEqualTo = _ref.greaterThanOrEqualTo,
        equalTo = _ref.equalTo,
        lessThan = _ref.lessThan,
        lessThanOrEqualTo = _ref.lessThanOrEqualTo,
        divisibleBy = _ref.divisibleBy,
        _ref$odd = _ref.odd,
        odd = _ref$odd === undefined ? false : _ref$odd,
        _ref$even = _ref.even,
        even = _ref$even === undefined ? false : _ref$even;

    _classCallCheck(this, NumberValidator);

    var _this = _possibleConstructorReturn(this, (NumberValidator.__proto__ || Object.getPrototypeOf(NumberValidator)).call(this));

    _this.messageNotNumber = messageNotNumber;
    _this.messageOnlyInteger = messageOnlyInteger;
    _this.messageGreaterThan = messageGreaterThan;
    _this.messageGreaterThanOrEqualTo = messageGreaterThanOrEqualTo;
    _this.messageEqualTo = messageEqualTo;
    _this.messageLessThan = messageLessThan;
    _this.messageLessThanOrEqualTo = messageLessThanOrEqualTo;
    _this.messageDivisibleBy = messageDivisibleBy;
    _this.messageNotOdd = messageNotOdd;
    _this.messageNotEven = messageNotEven;
    _this.strict = strict;
    _this.onlyInteger = onlyInteger;
    _this.greaterThan = greaterThan;
    _this.greaterThanOrEqualTo = greaterThanOrEqualTo;
    _this.equalTo = equalTo;
    _this.lessThan = lessThan;
    _this.lessThanOrEqualTo = lessThanOrEqualTo;
    _this.divisibleBy = divisibleBy;
    _this.odd = odd;
    _this.even = even;
    return _this;
  }

  _createClass(NumberValidator, [{
    key: 'validate',
    value: function validate(value, attribute, model) {
      // Empty values are fine
      if (!_utils2.default.isDefined(value) || _utils2.default.isEmpty(value)) {
        return Promise.resolve();
      }

      // Strict will check that it is a valid looking number
      if (_utils2.default.isString(value) && this.strict) {
        var pattern = '^(0|[1-9]\\d*)';
        if (!this.onlyInteger) {
          pattern += '(\\.\\d+)?';
        }
        pattern += '$';

        if (!new RegExp(pattern).test(value)) {
          return Promise.reject(this.createMessage(this.messageNotNumber || NumberValidator.MESSAGE_NOT_NUMBER, {
            attribute: attribute
          }));
        }
      }

      // Coerce the value to a number unless we're being strict.
      // if (options.noStrings !== true && utils.isString(value) && !utils.isEmpty(value)) {
      //     value = +value;
      // }

      value = +value;

      // If it's not a number we shouldn't continue since it will compare it.
      if (!_utils2.default.isNumber(value)) {
        return Promise.reject(this.createMessage(this.messageNotNumber || NumberValidator.MESSAGE_NOT_NUMBER, {
          attribute: attribute
        }));
      }

      // Same logic as above, sort of. Don't bother with comparisons if this
      // doesn't pass.
      if (this.onlyInteger && !_utils2.default.isInteger(value)) {
        return Promise.reject(this.createMessage(this.messageOnlyInteger || NumberValidator.MESSAGE_ONLY_INTEGER, {
          attribute: attribute
        }));
      }

      if (this.greaterThan !== undefined && _utils2.default.isNumber(this.greaterThan) && !(value > this.greaterThan)) {
        return Promise.reject(this.createMessage(this.messageGreaterThan || NumberValidator.MESSAGE_GREATER_THAN, {
          attribute: attribute,
          count: this.greaterThan
        }));
      }

      if (this.greaterThanOrEqualTo !== undefined && _utils2.default.isNumber(this.greaterThanOrEqualTo) && !(value >= this.greaterThanOrEqualTo)) {
        return Promise.reject(this.createMessage(this.messageGreaterThanOrEqualTo || NumberValidator.MESSAGE_GREATER_THAN_OR_EQUAL_TO, {
          attribute: attribute,
          count: this.greaterThanOrEqualTo
        }));
      }

      if (this.equalTo !== undefined && _utils2.default.isNumber(this.equalTo) && !(value === this.equalTo)) {
        return Promise.reject(this.createMessage(this.messageEqualTo || NumberValidator.MESSAGE_EQUAL_TO, {
          attribute: attribute,
          count: this.equalTo
        }));
      }

      if (this.lessThan !== undefined && _utils2.default.isNumber(this.lessThan) && !(value < this.lessThan)) {
        return Promise.reject(this.createMessage(this.messageLessThan || NumberValidator.MESSAGE_LESS_THAN, {
          attribute: attribute,
          count: this.lessThan
        }));
      }

      if (this.lessThanOrEqualTo !== undefined && _utils2.default.isNumber(this.lessThanOrEqualTo) && !(value <= this.lessThanOrEqualTo)) {
        return Promise.reject(this.createMessage(this.messageLessThanOrEqualTo || NumberValidator.MESSAGE_LESS_THAN_OR_EQUAL_TO, {
          attribute: attribute,
          count: this.lessThanOrEqualTo
        }));
      }

      if (this.divisibleBy !== undefined && _utils2.default.isNumber(this.divisibleBy) && !(value % this.divisibleBy === 0)) {
        return Promise.reject(this.createMessage(this.messageDivisibleBy || NumberValidator.MESSAGE_DIVISIBLE_BY, {
          attribute: attribute,
          count: this.divisibleBy
        }));
      }

      if (this.odd === true && Math.abs(value) % 2 !== 1) {
        return Promise.reject(this.createMessage(this.messageNotOdd || NumberValidator.MESSAGE_NOT_ODD, {
          attribute: attribute
        }));
      }

      if (this.even === true && Math.abs(value) % 2 !== 0) {
        return Promise.reject(this.createMessage(this.messageNotEven || NumberValidator.MESSAGE_NOT_EVEN, {
          attribute: attribute
        }));
      }

      return Promise.resolve();
    }
  }]);

  return NumberValidator;
}(_Validator3.default);

NumberValidator.MESSAGE_NOT_NUMBER = '{attribute} - must be a valid number';
NumberValidator.MESSAGE_ONLY_INTEGER = '{attribute} - must be an integer';
NumberValidator.MESSAGE_GREATER_THAN = '{attribute} - must be greater than {count}';
NumberValidator.MESSAGE_GREATER_THAN_OR_EQUAL_TO = '{attribute} - must be greater than or equal to {count}';
NumberValidator.MESSAGE_EQUAL_TO = '{attribute} - must be equal to {count}';
NumberValidator.MESSAGE_LESS_THAN = '{attribute} - must be less than {count}';
NumberValidator.MESSAGE_LESS_THAN_OR_EQUAL_TO = '{attribute} - must be less than or equal to {count}';
NumberValidator.MESSAGE_DIVISIBLE_BY = '{attribute} - must be divisible by {count}';
NumberValidator.MESSAGE_NOT_ODD = '{attribute} - must be odd';
NumberValidator.MESSAGE_NOT_EVEN = '{attribute} - must be even';
exports.default = NumberValidator;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/validators/NumberValidator.js
// module id = 770
// module chunks = 0